import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeTab: 'general',
};

const profileSlice = createSlice({
  name: "profileSlice",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload
    },
  },
});

export const { setActiveTab } = profileSlice.actions;

export const selectActiveTab = (state) => state?.profileSlice?.activeTab;

export default profileSlice.reducer;
